import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';

import getCardCategoriesQuery from '../../graphql/queries/getCardCategories';
import CardCategory from './components/CardCategory';
import useVirtualPageView from '../../../../apps/pro/services/analytics/useVirtualPageView';
import { PUSH_NOTIFICATION_TYPES } from './constants';

const propTypes = {
  className: PropTypes.string,
  cardCategories: PropTypes.shape({
    total: PropTypes.number.isRequired,
    records: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
    ).isRequired,
  }),
  onCategorySelect: PropTypes.func.isRequired,
  // Prop is used on the container below (withCardCategories)

  parentCardCategoryId: PropTypes.string,
};

const CardCategories = ({ className, cardCategories, onCategorySelect }) => {
  const classes = classNames({
    'card-categories-select': true,
    [className]: !!className,
  });

  useVirtualPageView({
    title: 'Create a card - Categories',
    path: '/categories',
  });

  if (!cardCategories) {
    // TODO [cards] Add placeholder
    return null;
  }

  return (
    <div className={classes}>
      <div className="card-category-grid">
        {cardCategories.records.map(cardCategory => {
          return (
            <CardCategory
              key={cardCategory.id}
              cardCategory={cardCategory}
              onClick={onCategorySelect}
            />
          );
        })}
      </div>
    </div>
  );
};

CardCategories.propTypes = propTypes;

const withCardCategories = graphql(getCardCategoriesQuery, {
  options: ({ parentCardCategoryId, enableHolidayCategories }) => {
    const excludedPushNotificationTypes = (() => {
      if (parentCardCategoryId) {
        return [];
      }

      return enableHolidayCategories
        ? [PUSH_NOTIFICATION_TYPES.SAVE_THE_DATE]
        : [
            PUSH_NOTIFICATION_TYPES.HOLIDAYS,
            PUSH_NOTIFICATION_TYPES.SAVE_THE_DATE,
          ];
    })();

    return {
      variables: {
        parent_card_category_id: parentCardCategoryId,
        excluded_push_notification_types: excludedPushNotificationTypes,
      },
    };
  },
  props: ({ data: { cardCategories } } = {}) => ({
    cardCategories,
  }),
});

export default compose(withCardCategories)(CardCategories);
